export enum AssignmentActionsEnum {
  CLOSE = 'close',
  REMOVE = 'remove',
  REOPEN = 'reOpen',

  INVITE = 'invite',
  DECISION = 'decision'
}
